import React, { useState,useContext } from 'react'

//internal
import PestTrapInspectionList from './PestTrapInspectionList';
import PestTrapInspectionReport from './PestTrapInspectionsReport';
import { StateManagerContext } from '../../contexts/statemanager';

//@material-ui
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import utils from '../../utils/utils';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ padding: '10px 0px 0px 0px' }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const PestTrapInspectionsComponent = () => {

    const [value, setValue] = useState(0);
		const { trapReportForceRefresh, setTrapReportForceRefresh, } = useContext(StateManagerContext);
	
    const handleChange = (event, newValue) => {
        setValue(newValue);
        utils.setLocalStorageItem("chartType",event.target.innerText);
				if(event.target.innerText==="REPORT") { setTrapReportForceRefresh(trapReportForceRefresh===""?null:""); }
    };

    return (
        <Box sx={{ bgcolor: 'background.paper', width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="inherit"
                    // variant="fullWidth"
                    TabIndicatorProps={{ style: { background: "#7A9A01" } }}
                >
                    <Tab label="Review" {...a11yProps(0)} />
                    <Tab label="Report" {...a11yProps(1)} />
                </Tabs>
            </Box>

            <TabPanel value={value} index={0}>
                <PestTrapInspectionList />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <PestTrapInspectionReport />
            </TabPanel>
        </Box>
    )
}

export default PestTrapInspectionsComponent;